import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { ComparisonSection } from './components/ComparisonSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { MaterialPreviewSection } from './components/MaterialPreviewSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { StickyCTABar } from './components/StickyCTABar';
export function App() {
  return <div className="min-h-screen w-full bg-white font-sans text-ink selection:bg-sage/25" data-id="element-0" data-mp="3mjgczu7zmpqf">
      <MetaPixel data-id="element-1" data-mp="3recf5n6xuth9" />
      <AnnouncementBar data-id="element-2" data-mp="5yjsutqtdfe" />
      <main data-id="element-3" data-mp="6hpnd64cbd2">
        <HeroSection data-id="element-4" data-mp="4wv3njt0sf7" />
        <StatsBar data-id="element-5" data-mp="5ghbgghm2z1" />
        <TransformationSection data-id="element-6" data-mp="82j0zgp5o9c" />
        <ComparisonSection data-id="element-7" data-mp="2zllff2q1qmn9" />
        <PainPointsSection data-id="element-8" data-mp="2zmepackaxs9m" />
        <KitContentsSection data-id="element-9" data-mp="2zn6actg9w7ln" />
        <MaterialPreviewSection data-id="element-10" data-mp="33mf25srr5vek" />
        <InstantAccessSection data-id="element-11" data-mp="33nq55qddiz4m" />
        <BonusesSection data-id="element-12" data-mp="33ori60dy9voz" />
        <PricingSection data-id="element-13" data-mp="38lrpsfqg76i7" />
        <GuaranteeSection data-id="element-14" data-mp="38li7zffk45nl" />
        <TestimonialsSection data-id="element-15" data-mp="38k6uup081ljt" />
        <FAQSection data-id="element-16" data-mp="38o4edbqpof48" />
        <FinalCTASection data-id="element-17" data-mp="3dkl0k0ecojeo" />
      </main>
      <Footer data-id="element-18" data-mp="3dlnwimqj5c1g" />
      <StickyCTABar data-id="element-19" data-mp="3dm60k5jfoujx" />
    </div>;
}